import {
  REVIEWS_WITH_COPYABLE_TEMPLATES_ROUTE,
  tokenizeRoute,
} from 'query/routes';
import { ID } from 'util/localTypes';

export type ReviewWithCopyableTemplate = {
  id: number;
  title: string;
  created_at: string;
};

type ReviewsWithCopyableTemplatesResponse = {
  source_reviews: ReviewWithCopyableTemplate[];
};

export const fetchReviewsWithCopyableTemplates = async (
  reviewId: ID
): Promise<ReviewsWithCopyableTemplatesResponse> => {
  const url = tokenizeRoute(REVIEWS_WITH_COPYABLE_TEMPLATES_ROUTE, {
    review_id: reviewId,
  });

  const res = await fetch(url.toString(), {
    method: 'GET',
    credentials: 'same-origin',
  });

  if (!res.ok) {
    throw new Error(res.statusText);
  }

  return res.json() as Promise<ReviewsWithCopyableTemplatesResponse>;
};
